import { post, get, put } from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS
} from '../../constants/notification-settings';

export const FETCH_USER_PERMISSIONS_START = 'FETCH_USER_PERMISSIONS_START';
export const FETCH_USER_PERMISSIONS_SUCCESS = 'FETCH_USER_PERMISSIONS_SUCCESS';
export const FETCH_USER_PERMISSIONS_FAIL = 'FETCH_USER_PERMISSIONS_FAIL';
export const FETCH_USER_PERMISSION_FAIL = 'FETCH_USER_PERMISSION_FAIL';
export const FETCH_USER_PERMISSION_START = 'FETCH_USER_PERMISSION_START';
export const FETCH_USER_PERMISSION_SUCCESS = 'FETCH_USER_PERMISSION_SUCCESS';
export const WRITE_USER_PERMISSION_START = 'WRITE_USER_GROUP_START';
export const WRITE_USER_PERMISSION_SUCCESS = 'WRITE_USER_GROUP_SUCCESS';
export const WRITE_USER_PERMISSION_FAIL = 'WRITE_USER_GROUP_FAIL';
export const CHANGE_USER_PERMISSION_SUCCESS = 'CHANGE_PERMISSION_GROUP_SUCCESS';
export const DELETE_USER_PERMISSION_SUCCESS = 'DELETE_USER_PERMISSION_SUCCESS';
export const FETCH_API_SECTIONS_START = 'FETCH_API_SECTIONS_START';
export const FETCH_API_SECTIONS_SUCCESS = 'FETCH_API_SECTIONS_SUCCESS';
export const FETCH_API_SECTIONS_FAIL = 'FETCH_API_SECTIONS_FAIL';

const fetchUserPermissionsStart = () => ({
  type: FETCH_USER_PERMISSIONS_START,
});

const fetchUserPermissionsAPISectionStart = () => ({
  type: FETCH_API_SECTIONS_START,
});

const fetchUserPermissionsAPISectionFail = () => ({
  type: FETCH_API_SECTIONS_FAIL,
});

const fetchUserPermissionsAPISectionSuccess = (payload) => ({
  type: FETCH_API_SECTIONS_SUCCESS,
  payload
});

export const fetchUserPermissionsSuccess = (payload) => ({
  type: FETCH_USER_PERMISSIONS_SUCCESS,
  payload,
});

const fetchUserPermissionsFail = (err) => ({
  type: FETCH_USER_PERMISSIONS_FAIL,
  payload: err,
});

export const deleteUserPermissionSuccess = (id) => ({
  type: DELETE_USER_PERMISSION_SUCCESS,
  payload: id,
});

const fetchUserPermissionStart = () => ({
  type: FETCH_USER_PERMISSION_START,
});

const fetchUserPermissionSuccess = (payload) => ({
  type: FETCH_USER_PERMISSION_SUCCESS,
  payload
});

const fetchUserPermissionFail = () => ({
  type: FETCH_USER_PERMISSION_FAIL,
});

export const writeUserPermissionStart = () => ({
  type: WRITE_USER_PERMISSION_START,
});

export const writeUserPermissionSuccess = (payload) => ({
  type: WRITE_USER_PERMISSION_SUCCESS,
  payload,
});

const writeUserPermissionFail = (err) => ({
  type: WRITE_USER_PERMISSION_FAIL,
  payload: err,
});

export const changeUserPermissionSuccess = (payload) => ({
  type: CHANGE_USER_PERMISSION_SUCCESS,
  payload,
});

export const fetchAllUserPermissions = () => async (dispatch) => {
  dispatch(fetchUserPermissionsStart());
  try {
    const result = await get('/user-permissions');
    dispatch(fetchUserPermissionsSuccess(result.data));
  } catch (e) {
    dispatch(fetchUserPermissionsFail(e));
  }
};

export const fetchAllAPISections = (lang) => async (dispatch) => {
  dispatch(fetchUserPermissionsAPISectionStart());
  try {
    // withMeta=1 — бэкенд добавляет к каждому эндпоинту requiredRule и dependsOn,
    // которые используются для подсказок зависимостей и обязательного правила.
    const result = await get(`/user-permissions/api-sections?langCode=${lang}&withMeta=1`);
    dispatch(fetchUserPermissionsAPISectionSuccess(result.data));
  } catch (e) {
    dispatch(fetchUserPermissionsAPISectionFail(e));
  }
};

export const fetchUserPermissionById = (id) => async (dispatch) => {
  dispatch(fetchUserPermissionStart());
  try {
    const result = await get(`/user-permissions/${id}`);
    dispatch(fetchUserPermissionSuccess(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchUserPermissionFail(e));
    return false;
  }
};

export const writeUserPermission = (data, translations, silent = true) => async (dispatch) => {
  dispatch(writeUserPermissionStart());
  try {
    const result = await post('/user-permissions', data);
    dispatch(writeUserPermissionSuccess(result.data));
    if (!silent) {
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    }
    return result.data.id;
  } catch (e) {
    console.error('writeUserPermission error:', e);
    dispatch(writeUserPermissionFail(e));
    if (!silent) {
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    }
    return null;
  }
};

export const changeUserPermission = (data, translations, silent = true) => async (dispatch) => {
  dispatch(writeUserPermissionStart());
  try {
    const result = await put(`/user-permissions/${data.id}`, data);
    dispatch(changeUserPermissionSuccess(result.data));
    if (!silent) {
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    }
    return true;
  } catch (e) {
    dispatch(writeUserPermissionFail(e));
    if (!silent) {
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    }
    return false;
  }
};

export const copyGroupPermissions = (sourceGroupId, destGroupId, translations) => async (dispatch) => {
  dispatch(writeUserPermissionStart());
  try {
    const result = await post(`/user-groups/${sourceGroupId}/permissions/copy-to/${destGroupId}`);
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return result.data;
  } catch (e) {
    dispatch(writeUserPermissionFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return null;
  }
};

/**
 * Массовое назначение всех существующих разрешений группе.
 * Возвращает { linked, opId } при успехе либо null при ошибке.
 * Тост об успехе показывает вызывающий компонент, т.к. ему нужно вывести
 * количество добавленных разрешений (linked).
 */
export const grantAllPermissions = (groupId, translations) => async (dispatch) => {
  dispatch(writeUserPermissionStart());
  try {
    const result = await post(`/user-groups/${groupId}/permissions/grant-all`);
    return result.data;
  } catch (e) {
    dispatch(writeUserPermissionFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return null;
  }
};

/**
 * Откат последней массовой операции группы (grant-all или copy-from).
 * Возвращает { removed, opId } при успехе либо null при ошибке; opId === null
 * означает, что откатывать нечего. Тост показывает вызывающий компонент.
 */
export const revertLastBulkPermissionsOp = (groupId, translations) => async (dispatch) => {
  dispatch(writeUserPermissionStart());
  try {
    const result = await post(`/user-groups/${groupId}/permissions/revert-last-bulk`);
    return result.data;
  } catch (e) {
    dispatch(writeUserPermissionFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return null;
  }
};
